// extracted by mini-css-extract-plugin
module.exports = {"body":"Product_body__12t9C","container":"Product_container__4KhDT"};